import { Chip, ChipBackgroundColor, ChipSize } from "@amzn/stencil-react-components/chip";
import React, { FC } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import type { AssetStatus } from "@/services/my-hardware/my-hardware.types";

const CHIP_COLOR_BY_STATUS: Record<AssetStatus, ChipBackgroundColor> = {
  overdueReturn: ChipBackgroundColor.Red,
  pendingReturn: ChipBackgroundColor.Yellow,
  eligibleForReplacement: ChipBackgroundColor.Blue,
  ordered: ChipBackgroundColor.Default,
  returnInProgress: ChipBackgroundColor.Default,
  assigned: ChipBackgroundColor.Default,
};

interface AssetStatusChipProps {
  status: AssetStatus;
  statusLabel?: string;
}

export const AssetStatusChip: FC<AssetStatusChipProps> = ({ status, statusLabel }) => (
  <Chip size={ChipSize.ExtraSmall} backgroundColor={CHIP_COLOR_BY_STATUS[status]}>
    {statusLabel ?? getString(`myHardware.assetStatus.${status}`)}
  </Chip>
);
